import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const StarFill = createSvgIcon(React.createElement("polygon", { points: "23.3,9.5 15.5,8.3 12,1.2 8.5,8.3 0.7,9.5 6.3,15 5,22.8 12,19.1 19,22.8 17.7,15 ", fill: "#000" }), 'StarFill');
export default StarFill;
